import { Injectable } from "@angular/core";
import { DataService } from "../data.service";
import { environment } from "../../../environments/environment";
@Injectable()
export class ResetPasswordService {
  constructor(private service: DataService) {}
  resetPassword(data:any, keyval:any) {
    return this.service.create(
      environment.resetPassword + "?keyval=" + keyval,
      data
    );
  }

  resetExpPassword(data:any) {
    return this.service.create(
      environment.resetExpPasswordUrl,
      data
    );
  }

}
